import { useInfiniteQuery } from '@northladder/services';

import { CUSTOMER_SERVICE_API } from '../customerServiceClient';
import { IFetchGradeDealsUrlOptions } from '../types';

/**
 * This is to track the grade deals list query in react query cache.
 */
export const FETCH_DEALS_LIST_FOR_GRADE_REQUEST_QUERY =
  'fetch-deals-list-for-grade-request-query-key';

interface IGradeReviewRequestListQuery {
  isEnabled: boolean;
  queryParams: IFetchGradeDealsUrlOptions;
}

/**
 * This hook will call to get delivered devices list.
 */
export const useDealsForGradeRequestSearchQuery = ({
  isEnabled,
  queryParams,
}: IGradeReviewRequestListQuery) => {
  const { appraisalCode, count } = queryParams;
  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    isPending,
    refetch,
  } = useInfiniteQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [FETCH_DEALS_LIST_FOR_GRADE_REQUEST_QUERY, appraisalCode],
    enabled: isEnabled,
    initialPageParam: 1,
    networkMode: 'always',
    retry: false,
    queryFn: ({ pageParam = 1 }) =>
      CUSTOMER_SERVICE_API.fetchDealsForGradeRequestSearchList({
        ...queryParams,
        page: pageParam,
      }),
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = allPages.length + 1;
      const currentCount = allPages.length * count;

      return currentCount < lastPage.count ? nextPage : undefined;
    },
  });

  return {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    isPending,
    refetch,
  };
};
